import type { RoleDefinition } from '../../../app/roles';

type MaskedValueProps = {
  value: string;
  role: RoleDefinition;
  type?: 'imei' | 'mac' | 'phone' | 'serial';
};

export function MaskedValue({ value, role, type = 'serial' }: MaskedValueProps) {
  if (role.id !== 'intern' || !value) return <span>{value}</span>;

  let masked = value;
  if (type === 'imei') {
    masked = '***' + value.slice(-5);
  } else if (type === 'mac') {
    masked = 'XX:XX:XX:XX:' + value.slice(-5);
  } else if (type === 'phone') {
    masked = '***-***-' + value.slice(-4);
  } else {
    masked = '***' + value.slice(-4);
  }

  return (
    <span className="masked-value" title="Value masked for your role">
      {masked}
    </span>
  );
}
